import React, { useState } from 'react'
import { prepareData } from 'utils/googleData'

export const FAQAccordionGrid = (props) => {
    const { enable, title, faqs, direction, className } = prepareData({ props })

    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }

    // Initialize an object where each key is the FAQ index and the value is a boolean representing its open state
    const initialOpenStates = faqs.reduce((acc, _, index) => ({ ...acc, [index]: false }), {})
    const [openStates, setOpenStates] = useState(initialOpenStates)

    const toggleFAQ = (index) => {
        setOpenStates((prevStates) => ({
            ...initialOpenStates, // Reset all to false to ensure only one can be open at a time (remove this line if multiple can be open)
            [index]: !prevStates[index],
        }))
    }

    return (
        <>
            <h2
                dir={direction}
                className={`m-0 mb-6 border-b border-dashed border-gray-accent-light pb-6 text-center text-2xl ${className}`}
            >
                {title}
            </h2>
            <section dir={direction} className={`grid grid-cols-1 gap-4 px-4 md:grid-cols-2 md:px-0`}>
                {faqs.map((faq, index) => {
                    const { q, a } = faq
                    return (
                        <div key={index} className="group">
                            <div
                                onClick={() => toggleFAQ(index)}
                                className="bg-gray-100 hover:bg-gray-200 cursor-pointer rounded-lg p-4 shadow"
                            >
                                <p className="font-semibold">{q}</p>
                            </div>
                            {openStates[index] && (
                                <div className="bg-gray-50 mt-2 rounded-lg p-4">
                                    <p className="text-gray-700">{a}</p>
                                </div>
                            )}
                        </div>
                    )
                })}
            </section>
        </>
    )
}

export default FAQAccordionGrid
